import { publicContextEnvelope, publicConversationContext } from './vibebeeConversation.mjs';
export const VISITOR_SESSION_KEY = 'v2n_visitor_plan_v1';
const TTL = 2 * 60 * 60 * 1000;
export function saveVisitorSession(storage, context, resolvedDate, now = Date.now()) {
  const safe = publicConversationContext(context);
  // Keep only bounded structured preferences/IDs, never messages, cards, audio,
  // provider tokens, coordinates or Admin context.
  safe.location.pending_origin_phrase = '';
  const patterns = {
    budget: /(?:[€£$]\s*\d+(?:\.\d+)?|\d+(?:\.\d+)?\s*euros?|cheap|budget|barato)/gi,
    group: /(?:(?:\d+|one|two|three|four|five|six|seven|eight|nine|ten|dos|tres|cuatro)\s*(?:people|persons|of us|personas)|family|children|kids|couple|solo|familia|pareja)/gi,
    needs: /(?:wheelchair|accessible|celiac|silla de ruedas|accesible)/gi,
    atmosphere: /(?:quieter|quiet|livelier|lively|tranquil[oa]|animado)/gi,
    walking: /(?:walking|walk|caminar|andar|a pie)/gi,
    transport: /(?:walking|driving|taxi|train|bus|coche|tren)/gi,
  };
  for (const [key, pattern] of Object.entries(patterns)) safe[key] = (safe[key].match(pattern) || []).join(' ').slice(0,160);
  if (resolvedDate && /^\d{4}-\d{2}-\d{2}$/.test(resolvedDate)) {
    const time = safe.dates.includes(' at ') ? safe.dates.split(' at ')[1] : '';
    safe.dates = resolvedDate + (time ? ` at ${time}` : '');
  }
  try { storage?.setItem(VISITOR_SESSION_KEY, JSON.stringify({version:1, savedAt:now, context: publicContextEnvelope(safe)})); } catch (_) { /* Storage denial cannot break chat. */ }
}
export function loadVisitorSession(storage, now = Date.now()) {
  try {
    const value = JSON.parse(storage?.getItem(VISITOR_SESSION_KEY) || 'null');
    if (!value || value.version !== 1 || !Number.isFinite(value.savedAt) || value.savedAt > now || now-value.savedAt > TTL) {
      storage?.removeItem(VISITOR_SESSION_KEY); return null;
    }
    return publicContextEnvelope(value.context);
  } catch (_) { return null; }
}
export function clearVisitorSession(storage) { try { storage?.removeItem(VISITOR_SESSION_KEY); } catch (_) {} }
export function visitorSummary(context, spanish=false) {
  const c=publicConversationContext(context);
  const names={marina:'Puerto Marina',carihuela:'La Carihuela','benalmadena costa':'Benalmádena Costa','benalmadena pueblo':'Benalmádena Pueblo',benalmadena:'Benalmádena','arroyo de la miel':'Arroyo de la Miel',torremolinos:'Torremolinos'};
  const roles={dinner:spanish?'Cena':'Dinner',drinks:spanish?'Copas':'Drinks',live_music:spanish?'Música':'Music'};
  const budget=(c.budget.match(/[€£$]\s*\d+(?:\.\d+)?|\d+(?:\.\d+)?\s*euros?|cheap|budget|barato/gi)||[]).join(' ');
  const atmosphere=(c.atmosphere.match(/quieter|quiet|livelier|lively|tranquil[oa]|animado/gi)||[]).join(' ');
  const group=(c.group.match(/(?:\d+|one|two|three|four|five|six|seven|eight|nine|ten|dos|tres|cuatro)\s*(?:people|persons|of us|personas)|family|children|kids|couple|solo|familia|pareja/gi)||[]).join(' ');
  return [c.location.origin_label || names[c.area] || c.area, c.dates, c.night_plan.requested_roles.map(r=>roles[r]).join(' + '), c.food, c.walking ? (spanish?'A pie':'Walking') : c.transport, budget, atmosphere, group].filter(Boolean);
}

export function visitorStorage() { try { return window.sessionStorage; } catch (_) { return null; } }

// Older compatible servers may omit optional state. Explicit empty values still
// clear a preference; an absent field must not erase the visitor's choices.
export function mergeVisitorContext(previous, response) {
  const base=publicContextEnvelope(previous);
  if (!response || !Object.keys(response).length) return base;
  if (response.version===2) return publicContextEnvelope({...base,...response,constraints:{...base.constraints,...response.constraints},conversation:{...base.conversation,...response.conversation}});
  const legacy=publicConversationContext(base);
  return publicContextEnvelope({...legacy,...response});
}
